import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

// A space plus a filename means the user picked a spreadsheet for this batch.
export const selectorIsImportBatchFileUploaded = (batch?: Batch): boolean =>
  !!batch?.metadata?.[BATCH_LABELS_WS_KEYS.flatfileBatchId] &&
  !!batch?.metadata?.[BATCH_LABELS_WS_KEYS.bulkImporterFilename];
